import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="entrypointserror" id="entrypointserror"></a>
    <h1 {...{
      "id": "entrypointserror"
    }}>{`EntryPointsError`}</h1>
    <p>{`Thrown whenever a call to `}<inlineCode parentName="p">{`entrypoints.setup`}</inlineCode>{` fails or is executed more than once.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      